module.exports = __webpack_public_path__ + "static/media/Tepig_gaussian2.b5765921.png";